export const getBaseQueryWithRejection = (baseQuery) => {
    return async (args, api, extraOptions) => {
        const result = await baseQuery(args, api, extraOptions);
        if (result.data && result.data.success === false) {
            return {
                error: {
                    status: 200,
                    data: result.data.message,
                },
            };
        }
        return result;
    };
};
